import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  recommendation_uuid: z.string().optional().catch(undefined),
  preview_token: z.string().optional().catch(undefined),
  candidate_name: z.string().optional().catch(undefined),
});

export type SearchSchema = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/_layoutAuth/_guest/join/')({
  validateSearch: searchSchema,
});
